import Vue from 'vue';
import Vuex from 'vuex';
import router, {
  constantRoutes,
  // asyncRoutes,
  // asyncRoutes4Member,
  // asyncRoutes4VipMember,
  // asyncRoutes4Manager,
  // asyncRoutes4Creator,
  publicRoutes,
  asyncRouteNameList,
  asyncRoute4MemberNameList,
  asyncRoute4VipMemberNameList,
  asyncRoute4ManagerNameList,
  asyncRoute4VipManagerNameList,
  // asyncRoutes4VipManager,
  asyncRoute4CreatorNameList,
  resetRouter,
  asyncCloudRoutes,
  asyncCloudRoutesNameList,
  asyncActConfRoutes,
  asyncActConfRoutesNameList,
} from '@/router';
import { getKfzInfo } from '@/api/common';
import { getStudioDetail } from '@/api/studio';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    downloadBle: 0,
    routes: constantRoutes(),
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    bankInfo: JSON.parse(sessionStorage.getItem('bankInfo') || '{}'),
    developerInfo: JSON.parse(sessionStorage.getItem('developerInfo') || '{}'),
    studioBaseInfo: JSON.parse(
      sessionStorage.getItem('studioBaseInfo') || '{}',
    ),
    backLabel: JSON.parse(sessionStorage.getItem('backLabel') || '{}'),
    i18nLangPkg: {},
    isNoviciateDeveloper: true
    //userTxt:JSON.parse(sessionStorage.getItem(userTxt))
  },
  mutations: {
    SET_DOWNLOADBLE(state, val) {
      state.downloadBle = val;
      sessionStorage.setItem('downloadBle', val);
    },
    SET_BACKLABEL(state, data) {
      state.backLabel = data;
      sessionStorage.setItem('backLabel', data);
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data;
      sessionStorage.setItem('userInfo', JSON.stringify(data));
    },
    CLEAR_ALL_INFO(state) {
      state.userInfo = {};
      sessionStorage.removeItem('userInfo');
      state.bankInfo = {};
      sessionStorage.removeItem('bankInfo');
      state.developerInfo = {};
      sessionStorage.removeItem('developerInfo');
      state.studioBaseInfo = {};
      sessionStorage.removeItem('studioBaseInfo');
    },
    RESET_ROUTER(state) {
      resetRouter();
      state.routes = constantRoutes();
    },
    SET_BANK_INFO(state, data) {
      state.bankInfo = data;
      sessionStorage.setItem('bankInfo', JSON.stringify(data));
    },
    SET_DEVELOPER_INFO(state, data) {
      state.developerInfo = data;
      sessionStorage.setItem('developerInfo', JSON.stringify(data));
    },
    SET_STUDIO_BASE_INFO(state, data) {
      state.studioBaseInfo = data;
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(data));
    },
    // 添加动态路由
    ADD_ASYNC_ROUTES(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncRouteNameList.includes(route.name),
      );

      if (hasAdded) return;

      let newRoutes = [...state.routes];
      // 添加动态路由
      // asyncRoutes.forEach(route => router.addRoute(route));

      // 更新 state
      // newRoutes.splice(1, 0, ...asyncRoutes);
      state.routes = newRoutes;
    },
    ADD_ASYNC_ROUTES_FOR_CLOUD(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncCloudRoutesNameList.includes(route.name),
      );

      if (hasAdded) return;

      asyncCloudRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Account') {
          accountIndex = i;
        }
      }

      if (accountIndex >= 0) {
        state.routes.splice(accountIndex, 0, ...asyncCloudRoutes);
      } else {
        let newRoutes = [...state.routes, ...asyncCloudRoutes];
        state.routes = newRoutes;
      }
    },
    ADD_ACT_CONF_ROUTES(state) {
      const hasAdded = !!state.routes.find(route =>
        asyncActConfRoutesNameList.includes(route.name),
      );

      if (hasAdded) return;
      asyncActConfRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Account') {
          accountIndex = i;
        }
      }

      if (accountIndex >= 0) {
        state.routes.splice(accountIndex, 0, ...asyncActConfRoutes);
      } else {
        let newRoutes = [...state.routes, ...asyncActConfRoutes];
        state.routes = newRoutes;
      }
    },
    ADD_ASYNC_ROUTES_FOR_ROLE(state, role) {
      let asyncRouteNameList, asyncRoutes;
      // if (role == 'vip_manager') {
      //   asyncRouteNameList = asyncRoute4VipManagerNameList;
      //   asyncRoutes = asyncRoutes4VipManager;
      // } else if (role === 'manager') {
      //   asyncRouteNameList = asyncRoute4ManagerNameList;
      //   asyncRoutes = asyncRoutes4Manager;
      // } else if (role === 'vipMember') {
      //   asyncRouteNameList = asyncRoute4VipMemberNameList;
      //   asyncRoutes = asyncRoutes4VipMember;
      // } else if (role === 'member') {
      //   asyncRouteNameList = asyncRoute4MemberNameList;
      //   asyncRoutes = asyncRoutes4Member;
      // } else if (role === 'studioCreator') {
      //   asyncRouteNameList = asyncRoute4CreatorNameList;
      //   asyncRoutes = asyncRoutes4Creator;
      // }
      // const hasAdded = !!state.routes.find(route =>
      //   asyncRouteNameList[0].startsWith(route.name),
      // );
      // if (hasAdded) return;
      // asyncRoutes.forEach(route => router.addRoute(route));

      let accountIndex = -1;
      for (let i = 0; i < state.routes.length; i++) {
        if (state.routes[i].name === 'Activity') {
          // 工作室插到激励计划前面
          accountIndex = i;
        }
        if (role.startsWith('vip') && state.routes[i].name === 'Income') {
          let EShopIndex = -1;
          for (let j = 0; j < state.routes[i].children.length; j++) {
            if (~state.routes[i].children[j].path.indexOf('/exchangeShop')) {
              EShopIndex = j;
            }
          }
          if (EShopIndex > -1) {
            state.routes[i].children.splice(EShopIndex, 1);
          }
        }
      }

      if (accountIndex >= 0) {
        // console.log(...asyncRoutes);
        // state.routes.splice(accountIndex, 0, ...asyncRoutes);
        console.log(state.routes);
      } else {
        // let newRoutes = [...state.routes, ...asyncRoutes];
        // state.routes = newRoutes;
      }
    },
    SET_LANG_PKG(state, pkgs) {
      state.i18nLangPkg = pkgs
    }
  },
  actions: {
    async addAsyncRoutes({ state, commit }) {
      const [
        { data: developerInfo },
        // { data: userInfo }
      ] = await Promise.all([getKfzInfo()]);
      // 收益管理相关路由
      // if (developerInfo.state === 1) {
      //   commit('ADD_ASYNC_ROUTES');
      // }
      const isCanuseeAct = localStorage.getItem('act_canusee' + state.userInfo.uin);
      console.log('act_canusee' + state.userInfo.uin, isCanuseeAct);
      if (isCanuseeAct == 1) {
        commit('ADD_ACT_CONF_ROUTES');
      }
      // 云服相关路由
      const apiid = parseInt(state.userInfo.apiid || 0, 10);
      const apiids = (
        window.apiidWhitelist[
          ~location.href.indexOf('-test') ? 'test' : 'prod'
        ] || []
      ).map(id => parseInt(id, 10));
      if (
        typeof state.userInfo.apiid === 'undefined' ||
        !apiids.length ||
        apiids.includes(apiid)
      ) {
        // commit('ADD_ASYNC_ROUTES_FOR_CLOUD');
      }

      // 工作室相关路由
      // if (studioBaseInfo) {
      //   if (
      //     developerInfo.studio_position === 1 &&
      //     developerInfo.member_vip === 1
      //   ) {
      //     commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'vip_manager');
      //   } else if (developerInfo.studio_position === 1) {
      //     commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'manager');
      //   } else if (developerInfo.member_vip === 1) {
      //     commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'vipMember');
      //   } else {
      //     commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'member');
      //   }
      // } else {
      //   commit('ADD_ASYNC_ROUTES_FOR_ROLE', 'studioCreator');
      // }
      // 添加公共路由，如 404
      router.addRoute(...publicRoutes);

      // 存储缓存
      commit('SET_DEVELOPER_INFO', developerInfo);
      // if (studioBaseInfo) {
      //   commit('SET_STUDIO_BASE_INFO', studioBaseInfo);
      // }
    },
    setI18nLangPkg({ commit }, payload) {
      // console.log(arguments)
      commit('SET_LANG_PKG', payload)
    },
    async refreshDeveloperInfo({ commit }) {
      const res = await getKfzInfo()
      commit('SET_DEVELOPER_INFO', res.data || {});
    }
  },
  modules: {},
});
